import { Agent } from '@nemuru-eng/js-api-client';

import { SelectItem } from '@/components/shared/components/AgentSelectionComponent/types/SelectItem';
import { ICON_NAMES } from '@/config/config';

export const AgentMap = {
  toSelectItem: (agent: Agent): SelectItem => {
    return {
      id: agent.id,
      name: agent.name,
      icon: ICON_NAMES.AGENT,
    };
  },
};
